// @flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { createClient } from '../../actions/forms'
import PageHeader from '../../components/PageHeader'
import ConsultationForm from './components/ConsultationForm'
import VirtualTours from '../../components/VirtualTours'

type Props = {
  createClient: Function
}

class Sell extends Component {
  props: Props

  handleSubmit = (data) => this.props.createClient(data)

  render() {
    return (
      <div>
        <Helmet title="Free Home Valuation" />
        <PageHeader text="Selling Your Home">
          Schedule a free home value consultation with a Kief Realty expert by
          filling out the form below. When marketing your home, we include a
          Matterport 3D virtual tour as part of our{' '}
          <Link to="hire-us">full-service suite</Link>.{' '}
          <b>Check out the 3D experience in one of our sample tours below!</b>
        </PageHeader>
        <VirtualTours />
        <div style={{ padding: '4rem 0' }}>
          <div className="container">
            <ConsultationForm
              onSubmit={this.handleSubmit}
              initialValues={{ state: 'IL' }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  { createClient }
)(Sell)



// WEBPACK FOOTER //
// ./src/views/Sell/index.js